import React, { useState, useEffect, forwardRef } from "react";
// react plugin for creating charts
import ChartistGraph from "react-chartist";
// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";
import Icon from "@material-ui/core/Icon";
// @material-ui/icons
import DateRange from "@material-ui/icons/DateRange";
import AccessTime from "@material-ui/icons/AccessTime";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Loader from "components/Loader/Loader";

import { dailySalesChart } from "variables/charts.js";

import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";

import moment from "moment";
import "moment/locale/es";

import { Redirect } from 'react-router-dom';

moment.locale("es");

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function a11yProps(index) {
  return {
    id: `tab-${index}`,
    'aria-controls': `tab-${index}`,
  };
}

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tab-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

const useStyles = makeStyles(styles);

export default function Dashboard() {
  const classes = useStyles();

  const [color, setColor] = useState("");
  const [message, setMessage] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const [load, setLoad] = useState(false);

  const [NumeroVentasGeneral, setNumeroVentasGeneral] = useState(0);
  const [NumeroVentasLinea, setNumeroVentasLinea] = useState(0);
  const [NumeroVentasBalance, setNumeroVentasBalance] = useState(0);
  const [NumeroVentasCash, setNumeroVentasCash] = useState(0);

  const [MontoVentasGeneral, setMontoVentasGeneral] = useState(0);
  const [MontoVentasLinea, setMontoVentasLinea] = useState(0);
  const [MontoVentasBalance, setMontoVentasBalance] = useState(0);
  const [MontoVentasCash, setMontoVentasCash] = useState(0);

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnackbar(false);
  };

  const sendSnackBar = (pmessage, pcolor) => {
    setOpenSnackbar(true);
    setColor(pcolor);
    setMessage(pmessage);
  };

  const convertToCSV = (objArray) => {
    const array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
    let str = "";

    for (let i = 0; i < array.length; i++) {
        let line = "";

        for (let index in array[i]) {
            if (line !== "") line += ",";
            line += array[i][index];
        }

        str += line + "\r\n";
    }

    return str;
  };

  const exportCSVFile = (headers, items, fileName) => {
    if (headers) {
        items.unshift(headers);
    }

    const jsonObject = JSON.stringify(items);
    const csv = convertToCSV(jsonObject);
    const exportName = fileName + ".csv" || "export.csv";
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

    if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, exportName);
    } else {
        const link = document.createElement("a");
        if (link.download !== undefined) {
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", exportName);
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
  };

  const exportaPendientes = (JSONData) => {
    if(GetIdRol() === 1){
      let arrData = typeof JSONData != "object" ? JSON.parse(JSONData) : JSONData;
      let reportTitle = "Reporte_Pendientes";
      let headers = {};

      arrData = arrData.map(item => { 
        return { 
          Referencia: "'" + item.Referencia.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""), 
          ReferenciaInvex: "'" + item.ReferenciaInvex.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
          Nombres: item.Nombres.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
          ApellidoPaterno: item.ApellidoPaterno.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
          ApellidoMaterno: item.ApellidoMaterno.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
          FechaNacimiento: item.FechaNacimiento.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
          RFC: item.RFC.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
          Correo: item.Correo.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
          Celular: item.Celular.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
          TelefonoFijo: item.TelefonoFijo.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
          TelefonoTrabajo: item.TelefonoTrabajo.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
          EstadoCivil: item.EstadoCivil.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
          GradoEstudios: item.GradoEstudios.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
          LugarNacimiento: item.LugarNacimiento.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
          Calle: item.Calle.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
          NumeroExterior: item.NumeroExterior.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
          NumeroInterior: item.NumeroInterior.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
          Colonia: item.Colonia.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
          Estado: item.Estado.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
          Localidad: item.Localidad.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
          CodigoPostal: item.CodigoPostal.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
          Banco: item.Banco.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
          ReferenciaTDC: item.ReferenciaTDC.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
          ReferenciaCreditoHipotecario: item.ReferenciaCreditoHipotecario.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
          ReferenciaCreditoAuto: item.ReferenciaCreditoAuto.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
          Producto: item.Producto.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
          Capturista: item.Capturista.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
          Validador: item.Validador.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
          IngresoMensual: item.IngresoMensual,
          Estatus: item.Estatus.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
          TipoBase: item.TipoBase.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
          FechaCaptura: item.FechaCaptura.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
          FechaSanitizacion: item.FechaSanitizacion.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
          FolioFico: item.FolioFico.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
          Pendiente: item.Pendiente.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
          Comentarios: item.Comentarios.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
          ActividadLaboral: item.ActividadLaboral.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
          CodigoPostalLaboral: item.CodigoPostalLaboral.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
          DependientesEconomicos: item.DependientesEconomicos.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
          FechaCapturista: item.FechaCapturista.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
          FechaValidador: item.FechaValidador.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, "")
        };
      });

      headers = {
          Referencia: "Referencia",
          ReferenciaInvex: "Referencia Invex",
          Nombres: "Nombres",
          ApellidoPaterno: "Apellido Paterno",
          ApellidoMaterno: "Apellido Materno",
          FechaNacimiento: "Fecha Nacimiento",
          RFC: "RFC",
          Correo: "Correo",
          Celular: "Celular",
          TelefonoFijo: "Telefono Fijo",
          TelefonoTrabajo: "Telefono Trabajo",
          EstadoCivil: "Estado Civil",
          GradoEstudios: "Grado Estudios",
          LugarNacimiento: "Lugar Nacimiento",
          Calle: "Calle",
          NumeroExterior: "Numero Exterior",
          NumeroInterior: "Numero Interior",
          Colonia: "Colonia",
          Estado: "Estado",
          Localidad: "Localidad",
          CodigoPostal: "Codigo Postal",
          Banco: "Banco",
          ReferenciaTDC: "Referencia TDC",
          ReferenciaCreditoHipotecario: "Referencia Credito Hipotecario",
          ReferenciaCreditoAuto: "Referencia Credito Auto",
          Producto: "Producto",
          Capturista: "Capturista",
          Validador: "Validador",
          IngresoMensual: "Ingreso Mensual",
          Estatus: "Estatus",
          TipoBase: "TipoBase",
          FechaCaptura: "FechaCaptura",
          FechaSanitizacion: "FechaSanitizacion",
          FolioFico: "FolioFico",
          Pendiente: "Pendiente",
          Comentarios: "Comentarios",
          ActividadLaboral: "ActividadLaboral",
          CodigoPostalLaboral: "CodigoPostalLaboral",
          DependientesEconomicos: "DependientesEconomicos",
          FechaCapturista: "FechaCapturista",
          FechaValidador: "FechaValidador"
      };
      
      exportCSVFile(headers, arrData, reportTitle);
    }
  };

  const exportaProcesadas = (JSONData) => {
    if(GetIdRol() === 1){
      let arrData = typeof JSONData != "object" ? JSON.parse(JSONData) : JSONData;
      let reportTitle = "Reporte_Procesadas";
      let headers = {};

      arrData = arrData.map(item => { 
        return { 
          Referencia: "'" + item.Referencia.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""), 
          ReferenciaInvex: "'" + item.ReferenciaInvex.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          Nombres: item.Nombres.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          ApellidoPaterno: item.ApellidoPaterno.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          ApellidoMaterno: item.ApellidoMaterno.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          FechaNacimiento: item.FechaNacimiento.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          RFC: item.RFC.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          Correo: item.Correo.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          Celular: item.Celular.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          TelefonoFijo: item.TelefonoFijo.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          TelefonoTrabajo: item.TelefonoTrabajo.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          EstadoCivil: item.EstadoCivil.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          GradoEstudios: item.GradoEstudios.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          LugarNacimiento: item.LugarNacimiento.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          Calle: item.Calle.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          NumeroExterior: item.NumeroExterior.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          NumeroInterior: item.NumeroInterior.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          Colonia: item.Colonia.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          Estado: item.Estado.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          Localidad: item.Localidad.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          CodigoPostal: item.CodigoPostal.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          Banco: item.Banco.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          ReferenciaTDC: item.ReferenciaTDC.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          ReferenciaCreditoHipotecario: item.ReferenciaCreditoHipotecario.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          ReferenciaCreditoAuto: item.ReferenciaCreditoAuto.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          Producto: item.Producto.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          Capturista: item.Capturista.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          Validador: item.Validador.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          IngresoMensual: item.IngresoMensual,
          Estatus: item.Estatus.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          TipoBase: item.TipoBase.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          FechaCaptura: item.FechaCaptura.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          FechaSanitizacion: item.FechaSanitizacion.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          FolioFico: item.FolioFico.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          Pendiente: item.Pendiente.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          Comentarios: item.Comentarios.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          ActividadLaboral: item.ActividadLaboral.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          CodigoPostalLaboral: item.CodigoPostalLaboral.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          DependientesEconomicos: item.DependientesEconomicos.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          FechaCapturista: item.FechaCapturista.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          FechaValidador: item.FechaValidador.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          Adicional: item.Adicional.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          Asistencia: item.Asistencia.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "")
        };
      });

      headers = {
          Referencia: "Referencia",
          ReferenciaInvex: "Referencia Invex",
          Nombres: "Nombres",
          ApellidoPaterno: "Apellido Paterno",
          ApellidoMaterno: "Apellido Materno",
          FechaNacimiento: "Fecha Nacimiento",
          RFC: "RFC",
          Correo: "Correo",
          Celular: "Celular",
          TelefonoFijo: "Telefono Fijo",
          TelefonoTrabajo: "Telefono Trabajo",
          EstadoCivil: "Estado Civil",
          GradoEstudios: "Grado Estudios",
          LugarNacimiento: "Lugar Nacimiento",
          Calle: "Calle",
          NumeroExterior: "Numero Exterior",
          NumeroInterior: "Numero Interior",
          Colonia: "Colonia",
          Estado: "Estado",
          Localidad: "Localidad",
          CodigoPostal: "Codigo Postal",
          Banco: "Banco",
          ReferenciaTDC: "Referencia TDC",
          ReferenciaCreditoHipotecario: "Referencia Credito Hipotecario",
          ReferenciaCreditoAuto: "Referencia Credito Auto",
          Producto: "Producto",
          Capturista: "Capturista",
          Validador: "Validador",
          IngresoMensual: "Ingreso Mensual",
          Estatus: "Estatus",
          TipoBase: "TipoBase",
          FechaCaptura: "FechaCaptura",
          FechaSanitizacion: "FechaSanitizacion",
          FolioFico: "FolioFico",
          Pendiente: "Pendiente",
          Comentarios: "Comentarios",
          ActividadLaboral: "ActividadLaboral",
          CodigoPostalLaboral: "CodigoPostalLaboral",
          DependientesEconomicos: "DependientesEconomicos",
          FechaCapturista: "FechaCapturista",
          FechaValidador: "FechaValidador",
          Adicional: "Adicional",
          Asistencia: "Asistencia"
      };
      
      exportCSVFile(headers, arrData, reportTitle);
    }
  };

  const exportaAprobadas = (JSONData) => {
    if(GetIdRol() === 1){
      let arrData = typeof JSONData != "object" ? JSON.parse(JSONData) : JSONData;
      let reportTitle = "Reporte_Aprobadas";
      let headers = {};

      arrData = arrData.map(item => { 
        return { 
          Referencia: "'" + item.Referencia.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""), 
          ReferenciaInvex: "'" + item.ReferenciaInvex.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          Nombres: item.Nombres.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          ApellidoPaterno: item.ApellidoPaterno.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          ApellidoMaterno: item.ApellidoMaterno.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          FechaNacimiento: item.FechaNacimiento.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          RFC: item.RFC.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          Correo: item.Correo.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          Celular: item.Celular.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          TelefonoFijo: item.TelefonoFijo.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          TelefonoTrabajo: item.TelefonoTrabajo.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          EstadoCivil: item.EstadoCivil.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          GradoEstudios: item.GradoEstudios.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          LugarNacimiento: item.LugarNacimiento.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          Calle: item.Calle.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          NumeroExterior: item.NumeroExterior.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          NumeroInterior: item.NumeroInterior.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          Colonia: item.Colonia.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          Estado: item.Estado.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          Localidad: item.Localidad.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          CodigoPostal: item.CodigoPostal.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          Banco: item.Banco.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          ReferenciaTDC: item.ReferenciaTDC.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          ReferenciaCreditoHipotecario: item.ReferenciaCreditoHipotecario.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          ReferenciaCreditoAuto: item.ReferenciaCreditoAuto.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          Producto: item.Producto.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          Capturista: item.Capturista.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          Validador: item.Validador.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          IngresoMensual: item.IngresoMensual,
          Estatus: item.Estatus.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          TipoBase: item.TipoBase.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          FechaCaptura: item.FechaCaptura.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          FechaSanitizacion: item.FechaSanitizacion.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          FolioFico: item.FolioFico.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          Pendiente: item.Pendiente.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          Comentarios: item.Comentarios.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          ActividadLaboral: item.ActividadLaboral.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          CodigoPostalLaboral: item.CodigoPostalLaboral.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          DependientesEconomicos: item.DependientesEconomicos.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          FechaCapturista: item.FechaCapturista.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", ""),
          FechaValidador: item.FechaValidador.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "")
        };
      });

      headers = {
          Referencia: "Referencia",
          ReferenciaInvex: "Referencia Invex",
          Nombres: "Nombres",
          ApellidoPaterno: "Apellido Paterno",
          ApellidoMaterno: "Apellido Materno",
          FechaNacimiento: "Fecha Nacimiento",
          RFC: "RFC",
          Correo: "Correo",
          Celular: "Celular",
          TelefonoFijo: "Telefono Fijo",
          TelefonoTrabajo: "Telefono Trabajo",
          EstadoCivil: "Estado Civil",
          GradoEstudios: "Grado Estudios",
          LugarNacimiento: "Lugar Nacimiento",
          Calle: "Calle",
          NumeroExterior: "Numero Exterior",
          NumeroInterior: "Numero Interior",
          Colonia: "Colonia",
          Estado: "Estado",
          Localidad: "Localidad",
          CodigoPostal: "Codigo Postal",
          Banco: "Banco",
          ReferenciaTDC: "Referencia TDC",
          ReferenciaCreditoHipotecario: "Referencia Credito Hipotecario",
          ReferenciaCreditoAuto: "Referencia Credito Auto",
          Producto: "Producto",
          Capturista: "Capturista",
          Validador: "Validador",
          IngresoMensual: "Ingreso Mensual",
          Estatus: "Estatus",
          TipoBase: "TipoBase",
          FechaCaptura: "FechaCaptura",
          FechaSanitizacion: "FechaSanitizacion",
          FolioFico: "FolioFico",
          Pendiente: "Pendiente",
          Comentarios: "Comentarios",
          ActividadLaboral: "ActividadLaboral",
          CodigoPostalLaboral: "CodigoPostalLaboral",
          DependientesEconomicos: "DependientesEconomicos",
          FechaCapturista: "FechaCapturista",
          FechaValidador: "FechaValidador"
      };
      
      exportCSVFile(headers, arrData, reportTitle);
    }
  };

  const Login = async () => {
    let dataResponse;
    try {
        let header = {
            method: "POST",
            body: JSON.stringify({UserName: process.env.REACT_APP_USER, Password: process.env.REACT_APP_PASS}),
            headers: {
                "Content-Type": "application/json"
            }
        };

        let response = await fetch(
            process.env.REACT_APP_URL_APICORE + "Login",
            header
        );

        dataResponse = await response.json();
    } catch (error) {
        sendSnackBar("Error de conexión", "error");
    }

    return dataResponse;
  };

  const GetIdSucursal = () => {
    return JSON.parse(localStorage.getItem('userICR')).IdSucursales;
  };

  const GetIdRol = () => {
    return JSON.parse(localStorage.getItem('userICR')).idRol;
  };

  const ObtieneCuentaMontos = async (data, token) => {
    let dataResponse;
    try {
        let header = {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token
            }
        };

        let response = await fetch(
            process.env.REACT_APP_URL_APICORE + "CapturaPrestamo/ObtieneCuentaMontos",
            header
        );

        dataResponse = await response.json();
    } catch (error) {
        sendSnackBar("Error de conexión", "error");
    }

    return dataResponse;
  };

  const ReporteProcesadas = async (data, token) => {
    let dataResponse;
    try {
        let header = {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token
            }
        };

        let response = await fetch(
            process.env.REACT_APP_URL_APICORE + "Reportes/ReporteProcesadas",
            header
        );

        dataResponse = await response.json();
    } catch (error) {
        sendSnackBar("Error de conexión", "error");
    }

    return dataResponse;
  };

  const ReporteAprobadas = async (data, token) => {
    let dataResponse;
    try {
        let header = {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token
            }
        };

        let response = await fetch(
            process.env.REACT_APP_URL_APICORE + "Reportes/ReporteAprobadas",
            header
        );

        dataResponse = await response.json();
    } catch (error) {
        sendSnackBar("Error de conexión", "error");
    }

    return dataResponse;
  };

  const PromedioAutenticacion = async (data, token) => {
    let dataResponse;
    try {
        let header = {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token
            }
        };

        let response = await fetch(
            process.env.REACT_APP_URL_APICORE + "Reportes/PromedioAutenticacion",
            header
        );

        dataResponse = await response.json();
    } catch (error) {
        sendSnackBar("Error de conexión", "error");
    }

    return dataResponse;
  };

  const PromedioAprobacion = async (data, token) => {
    let dataResponse;
    try {
        let header = {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token
            }
        };

        let response = await fetch(
            process.env.REACT_APP_URL_APICORE + "Reportes/PromedioAprobacion",
            header
        );

        dataResponse = await response.json();
    } catch (error) {
        sendSnackBar("Error de conexión", "error");
    }

    return dataResponse;
  };

  const GetIdUsuario = () => {
    return JSON.parse(localStorage.getItem('userICR')).IdUsuario;
  };

  const UsuarioActivo = async (data, token) => {
    let dataResponse;
    try {
        let header = {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token
            }
        };

        let response = await fetch(
            process.env.REACT_APP_URL_APICORE + "Usuario/UsuarioActivo",
            header
        );

        dataResponse = await response.json();
    } catch (error) {
        sendSnackBar("Error de conexión", "error");
    }

    return dataResponse;
  };

  useEffect(() => {
    setLoad(true);

    Login()
    .then(result => {
      let token = result.token;

      UsuarioActivo({ IdUsuario: GetIdUsuario() },token)
      .then(result => {
        if(result.activo === false){
          localStorage.removeItem("userICR");
          return <Redirect to='/admin'/>;
        }
      });

      let fechaInicio = moment(Date.now());
      fechaInicio.set({h: 0, m: 0, s: 0});

      let fechaFin = moment(Date.now());
      fechaFin.set({h: 23, m: 59, s: 59});

      let montos = {
        FechaInicio: fechaInicio.format("YYYY/MM/DD HH:mm:ss"),
        FechaFin: fechaFin.format("YYYY/MM/DD HH:mm:ss"),
        IdEstatusPrestamo: 1
      };

      //LINEA PARALELA
      ObtieneCuentaMontos(montos, result.token)
      .then(result => {
        setMontoVentasLinea(parseInt(result.cuentaMontos[0].MontoSuma));
        setNumeroVentasLinea(parseInt(result.cuentaMontos[0].MontoCuenta));
        setMontoVentasGeneral(prev => prev + parseInt(result.cuentaMontos[0].MontoSuma));
        setNumeroVentasGeneral(prev => prev + parseInt(result.cuentaMontos[0].MontoCuenta));
      });

      //BALANCE TRANSFER
      montos["IdEstatusPrestamo"] = 2;
      ObtieneCuentaMontos(montos, result.token)
      .then(result => {
        setMontoVentasBalance(parseInt(result.cuentaMontos[0].MontoSuma));
        setNumeroVentasBalance(parseInt(result.cuentaMontos[0].MontoCuenta));
        setMontoVentasGeneral(prev => prev + parseInt(result.cuentaMontos[0].MontoSuma));
        setNumeroVentasGeneral(prev => prev + parseInt(result.cuentaMontos[0].MontoCuenta));
      });

      //INVEX CASH
      montos["IdEstatusPrestamo"] = 3;
      ObtieneCuentaMontos(montos, result.token)
      .then(result => {
        setLoad(false);
        setMontoVentasCash(parseInt(result.cuentaMontos[0].MontoSuma));
        setNumeroVentasCash(parseInt(result.cuentaMontos[0].MontoCuenta));
        setMontoVentasGeneral(prev => prev + parseInt(result.cuentaMontos[0].MontoSuma));
        setNumeroVentasGeneral(prev => prev + parseInt(result.cuentaMontos[0].MontoCuenta));
      });
    });
  }, []);

  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={6} md={6}>
          <Card>
            <CardHeader stats icon>
              <p className={classes.cardCategory}>Número de ventas</p>
              <h3 className={classes.cardTitle}>{NumeroVentasGeneral}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <DateRange />
                Últimas 24 Horas
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={6} md={6}>
          <Card>
            <CardHeader stats icon>
              <p className={classes.cardCategory}>Monto de ventas</p>
              <h3 className={classes.cardTitle}>{"$" + MontoVentasGeneral.toLocaleString('es-MX')}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <DateRange />
                Últimas 24 Horas
              </div>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>
      <Box sx={{ width: '100%', padding: "20px" }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={value} onChange={handleChange} aria-label="abs" centered>
            <Tab label="Linea Paralela" {...a11yProps(0)} />
            <Tab label="Balance Transfer" {...a11yProps(1)} />
            <Tab label="Invex Cash" {...a11yProps(2)} />
          </Tabs>
        </Box>
        <CustomTabPanel value={value} index={0}>
          <GridContainer>
            <GridItem xs={12} sm={6} md={6}>
              <Card>
                <CardHeader stats icon>
                  <p className={classes.cardCategory}>Número de ventas</p>
                  <h3 className={classes.cardTitle}>{NumeroVentasLinea}</h3>
                </CardHeader>
                <CardFooter stats>
                  <div className={classes.stats}>
                    <DateRange />
                    Últimas 24 Horas
                  </div>
                </CardFooter>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
              <Card>
                <CardHeader stats icon>
                  <p className={classes.cardCategory}>Monto de ventas</p>
                  <h3 className={classes.cardTitle}>{"$" + MontoVentasLinea.toLocaleString('es-MX')}</h3>
                </CardHeader>
                <CardFooter stats>
                  <div className={classes.stats}>
                    <DateRange />
                    Últimas 24 Horas
                  </div>
                </CardFooter>
              </Card>
            </GridItem>
          </GridContainer>
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <GridContainer>
            <GridItem xs={12} sm={6} md={6}>
              <Card>
                <CardHeader stats icon>
                  <p className={classes.cardCategory}>Número de ventas</p>
                  <h3 className={classes.cardTitle}>{NumeroVentasBalance}</h3>
                </CardHeader>
                <CardFooter stats>
                  <div className={classes.stats}>
                    <DateRange />
                    Últimas 24 Horas
                  </div>
                </CardFooter>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
              <Card>
                <CardHeader stats icon>
                  <p className={classes.cardCategory}>Monto de ventas</p>
                  <h3 className={classes.cardTitle}>{"$" + MontoVentasBalance.toLocaleString('es-MX')}</h3>
                </CardHeader>
                <CardFooter stats>
                  <div className={classes.stats}>
                    <DateRange />
                    Últimas 24 Horas
                  </div>
                </CardFooter>
              </Card>
            </GridItem>
          </GridContainer>
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          <GridContainer>
            <GridItem xs={12} sm={6} md={6}>
              <Card>
                <CardHeader stats icon>
                  <p className={classes.cardCategory}>Número de ventas</p>
                  <h3 className={classes.cardTitle}>{NumeroVentasCash}</h3>
                </CardHeader>
                <CardFooter stats>
                  <div className={classes.stats}>
                    <DateRange />
                    Últimas 24 Horas
                  </div>
                </CardFooter>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={6} md={6}>
              <Card>
                <CardHeader stats icon>
                  <p className={classes.cardCategory}>Monto de ventas</p>
                  <h3 className={classes.cardTitle}>{"$" + MontoVentasCash.toLocaleString('es-MX')}</h3>
                </CardHeader>
                <CardFooter stats>
                  <div className={classes.stats}>
                    <DateRange />
                    Últimas 24 Horas
                  </div>
                </CardFooter>
              </Card>
            </GridItem>
          </GridContainer>
        </CustomTabPanel>
      </Box>
      <Snackbar anchorOrigin={{ vertical: "bottom", horizontal: "right" }} open={openSnackbar} onClose={handleClose} autoHideDuration={6000}>
            <Alert onClose={handleClose} severity={color} sx={{ width: '100%' }}>
                {message}
            </Alert>
      </Snackbar>
      <Loader load={load} />
    </div>
  );
}
